import {
  PIPEFITTER_SET_REPORTS_LOADING,
  PIPEFITTER_SET_PIPE_STATISTICS,
  PIPEFITTER_SET_PIPE_STATUS,
  PIPEFITTER_SET_PIPE_STATUS_PAGINATION,
  PIPEFITTER_SET_PIPE_STATUS_LOADING_MORE,
  PIPEFITTER_SET_PIPE_DATA_GRAPH,
  PIPEFITTER_SET_PROJECT_STATUS_PIPE_DATA,
  PIPEFITTER_SET_PROJECT_SUMMARY_DATA,
  PIPEFITTER_SET_PIPES_LIST_FILTERED,
} from './types';

const initialState = {
  isReportsLoading: false,
  pipeStatistics: {},
  pipeStatusData: [],
  /** Total rows reported by API (full project list size). */
  pipeStatusTotalCount: null,
  /** Client-side table page offset (not sent to API). */
  pipeStatusSkip: 0,
  pipeStatusLimit: 25,
  pipeStatusLoadingMore: false,
  pipeStatusFetchComplete: false,
  pipesListFiltered: [],
  pipeDataGraph: [],
  projectStatusPipeData: [],
  projectSummaryData: [],
};

export default function pipefitterReportsReducer(state = initialState, action) {
  switch (action.type) {
    case PIPEFITTER_SET_REPORTS_LOADING:
      return { ...state, isReportsLoading: action.payload };
    case PIPEFITTER_SET_PIPE_STATISTICS:
      return { ...state, pipeStatistics: action.payload };
    case PIPEFITTER_SET_PIPE_STATUS: {
      const p = action.payload;
      if (Array.isArray(p)) {
        return {
          ...state,
          pipeStatusData: p,
          pipeStatusTotalCount: null,
          pipeStatusSkip: 0,
          pipeStatusLimit: state.pipeStatusLimit ?? 25,
          pipeStatusLoadingMore: false,
          pipeStatusFetchComplete: true,
        };
      }
      if (p?.append) {
        const incoming = Array.isArray(p?.data) ? p.data : [];
        const merged = [...state.pipeStatusData, ...incoming];
        const totalCount =
          p?.totalCount != null && p.totalCount !== ''
            ? Number(p.totalCount)
            : state.pipeStatusTotalCount;
        return {
          ...state,
          pipeStatusData: merged,
          pipeStatusTotalCount: Number.isFinite(totalCount) ? totalCount : state.pipeStatusTotalCount,
          pipeStatusLoadingMore: p?.loadingMore === true,
          pipeStatusFetchComplete: p?.fetchComplete === true,
        };
      }
      const list = Array.isArray(p?.data) ? p.data : [];
      const totalCount = p?.totalCount != null && p.totalCount !== '' ? Number(p.totalCount) : null;
      const limitRaw = p?.limit != null && p.limit !== '' ? Number(p.limit) : (state.pipeStatusLimit ?? 25);
      const limit = Math.min(500, Math.max(1, Number.isFinite(limitRaw) ? limitRaw : 25));
      return {
        ...state,
        pipeStatusData: list,
        pipeStatusTotalCount: Number.isFinite(totalCount) ? totalCount : null,
        pipeStatusSkip: 0,
        pipeStatusLimit: limit,
        pipeStatusLoadingMore: p?.loadingMore === true,
        pipeStatusFetchComplete: p?.fetchComplete === true,
      };
    }
    case PIPEFITTER_SET_PIPE_STATUS_PAGINATION: {
      const p = action.payload ?? {};
      const skip = p?.skip != null && p.skip !== '' ? Math.max(0, Number(p.skip) || 0) : 0;
      const limitRaw = p?.limit != null && p.limit !== '' ? Number(p.limit) : (state.pipeStatusLimit ?? 25);
      const limit = Math.min(500, Math.max(1, Number.isFinite(limitRaw) ? limitRaw : 25));
      return { ...state, pipeStatusSkip: skip, pipeStatusLimit: limit };
    }
    case PIPEFITTER_SET_PIPE_STATUS_LOADING_MORE:
      return { ...state, pipeStatusLoadingMore: Boolean(action.payload) };
    case PIPEFITTER_SET_PIPES_LIST_FILTERED:
      return { ...state, pipesListFiltered: action.payload };
    case PIPEFITTER_SET_PIPE_DATA_GRAPH:
      return { ...state, pipeDataGraph: action.payload };
    case PIPEFITTER_SET_PROJECT_STATUS_PIPE_DATA:
      return { ...state, projectStatusPipeData: action.payload };
    case PIPEFITTER_SET_PROJECT_SUMMARY_DATA:
      return { ...state, projectSummaryData: action.payload };
    default:
      return state;
  }
}
